import React from "react";
import PremiumResourcePage, { resourceMoney } from "../../../Components/Dashboard/PremiumResourcePage";

const mergePayments = (data) => {
  const mergedData = [];
  (data || []).forEach((group) => {
    (group || []).forEach((item) => {
      const existingRow = mergedData.find((row) => row.paymentCount === item.paymentCount);
      if (!existingRow) {
        mergedData.push({ ...item, invoices: [item.invoiceNumber] });
      } else {
        existingRow.invoices.push(item.invoiceNumber);
      }
    });
  });
  return mergedData;
};

const PaymentRecieved = ({ navigation }) => (
  <PremiumResourcePage
    navigation={navigation}
    title="Payments Received"
    subtitle="Track customer payments, modes, references, and linked invoices."
    createRoute="PaymentRecivedNew"
    createLabel="+ New Payment"
    fetchEndpoint="/fetchPaymentReceived2"
    transformRows={mergePayments}
    totalKey="payment"
    columns={[
      { key: "serial", label: "Serial No." },
      { key: "paymentDate", label: "Date" },
      { key: "paymentCount", label: "Payment #" },
      { key: "reference", label: "Reference" },
      { key: "customerName", label: "Customer Name" },
      { key: "invoices", label: "Invoices", render: (row) => (row.invoices || []).join(", ") || "-" },
      { key: "paymentMode", label: "Mode" },
      { key: "payment", label: "Amount", className: "premium-money", render: (row) => resourceMoney(row.payment) },
    ]}
  />
);

export default PaymentRecieved;
